module.exports = __webpack_public_path__ + "img/form-5.c5b21136.svg";